import { render, staticRenderFns } from "./contribute.vue?vue&type=template&id=10fcd80a&scoped=true&"
import script from "./contribute.vue?vue&type=script&lang=js&"
export * from "./contribute.vue?vue&type=script&lang=js&"
import style0 from "./contribute.vue?vue&type=style&index=0&id=10fcd80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fcd80a",
  null
  
)

export default component.exports